import React, { useState } from "react";
import axios from "axios";
import { CiDeliveryTruck } from "react-icons/ci";
import { IoCashOutline } from "react-icons/io5";
import { AiOutlineTruck } from "react-icons/ai";

const DeliverySection = () => {
  const [inputValue, setInputValue] = useState("");
  const [valid, setValid] = useState();

  const handleInputChange = (e) => {
    const { value } = e.target;
    if (/^\d{0,6}$/.test(value)) {
      setInputValue(value);
    }
  };

  const handleCheckClick = async () => {
    if (inputValue.length === 6) {
      try {
        const response = await axios.get(
          `https://api.postalpincode.in/pincode/${inputValue}`
        );
        const data = response.data[0];
        if (data.Status === "Success") {
          setValid("valid");
        } else {
          setValid("notValid");
        }
      } catch (error) {
        console.error("Error fetching the PIN code data:", error);
      }
    } else {
      setValid("notValid");
    }
  };

  return (
    <div className="mt-4 font-twentieth-century shadow-lg p-4 rounded-lg transition duration-400 ease-in-out transform hover:shadow-2xl hover:-translate-y-1 hover:-translate-x-1">
      <p className="mb-1 font-medium text-gray-700">
        Estimated Delivery Date & COD Checker
      </p>
      <div className="flex items-center space-x-2">
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          className="border rounded-lg w-full px-3 py-2 text-gray-700 focus:outline-none focus:ring-1 focus:ring-gray-600"
          placeholder="Enter your PIN code"
        />
        <button
          onClick={handleCheckClick}
          className="bg-black text-white rounded-lg px-4 py-2 hover:bg-gray-800"
        >
          Check
        </button>
      </div>
      {valid === "valid" && (
        <div className={`mt-2`}>
          <p className="flex items-center">
            <AiOutlineTruck className="mr-2" /> Expect delivery by{" "}
            <span className="text-green-600 ml-2">3-5 business days</span>
          </p>
          <p className="flex items-center mt-1">
            <IoCashOutline className="mr-2" /> Cash on delivery{" "}
            <span className="text-green-600 ml-2">available</span>
          </p>
        </div>
      )}
      {valid === "notValid" && (
        <div className={`mt-2`}>Please enter a valid pincode</div>
      )}
    </div>
  );
};

export default DeliverySection;
